import React, { Component } from 'react';
import './App.css';
import Home from './components/Home/Home';
import Zimmer from './components/Zimmer/Zimmer';
import WeatherWidget from './components/WeatherWidget/WeatherWidget';
import Footer from './components/Footer/Footer';
import Overlay from './components/Overlay/Overlay';
import Section from './components/Section/Section';
// import BookingOverlay from './components/BookingOverlay/BookingOverlay';
import Header from './components/Header/Header';
import BodyScroll from './components/BodyScroll/BodyScroll';
import { browserHistory } from 'react-router';

import Scroll from 'react-scroll';

class App extends Component {

    constructor(props) {
        super(props);

        this.state = {
            configLoaded: false,
            showWeatherWidget: true,
            data: [], // JSON-DATA
            headline: "",
            home: {},
            news: {},
            hotel: {},
            region: {},
            rooms: {},
            buchen: {},
            roomPanels: [],
            seasons: {},
            restaurant: {},
            anfahrt: {},
            sonstiges: {},
            overlay: {title: "", isVisible: false, articles: {}, rooms: {}, type: "", idx: -1},
            bookingOverlay: {title: "", isVisible: false},
        };


        if (process.env.NODE_ENV !== "production") {
            //this.apiUrl = "http://localhost/schorsow/dev/landhotel-schorsow.de/kirby/api/";
            this.apiUrl = "http://localhost/landhotel-schorssow.de/kirby/api/";
            // this.apiUrl = "http://allconas.de/kirby/api/";
            this.apiUrl = "https://www.landhotel-schorssow.de/kirby/api/";
        } else {
            this.apiUrl = "https://www.landhotel-schorssow.de/kirby/api/";
            //this.apiUrl = "https://preview.landhotel-schorssow.de/kirby/api/";
            //this.apiUrl = "https://allconas.de/kirby/api/";
        }

        this.Events     = Scroll.Events;
        this.scrollSpy  = Scroll.scrollSpy;
        this.scroll     = Scroll.animateScroll;

    }

    componentDidMount() {
        fetch(this.apiUrl)
            .then( (response) => {
                return response.json() })
            .then( (json) => {
                this.setState({
                    data: json
                });
                setTimeout(() => {this.checkDeeplink()}, 1000);
            });

/*
        this.Events.scrollEvent.register('begin', function(to, element) {
            //console.log(("begin", arguments);
        });

        this.Events.scrollEvent.register('end', function(to, element) {
            //console.log(("end", arguments);
        });

        this.scrollSpy.update();*/

        window.onhashchange = function () {
            ////console.log(("hash - : " + window.location.hash);
            browserHistory.push(window.location.hash.split('#').join(''));
        }

    };

    checkDeeplink () {

        var currLocation = window.location.href;

        if (currLocation !== "") {
            currLocation = currLocation.split("https://").join("");
            currLocation = currLocation.split("http://").join("");
            var lastIdx = currLocation.split("/");
            var link = "";
            if (lastIdx.length === 3) {
                link = "/" + lastIdx[lastIdx.length-2] + "/" + lastIdx[lastIdx.length-1];
            } else {
                link = "/" + lastIdx[lastIdx.length-1];
            }
            ////console.log(("call link", link);

            browserHistory.push(link);

        }
    }

    getChildContext() {
        return {
            scroll: this.scroll
        };
    }

    static childContextTypes = {
        scroll: React.PropTypes.object
    }


    componentDidUpdate() {
        if (!this.configLoaded) {
            var s = this.state;

            for (var i = 0; i < this.state.data.length; i++) {
                let obj = this.state.data[i];

                ////console.log(("App - componentDidUpdate: " + obj.title.toString().toLowerCase());

                switch (obj.id.toString().toLowerCase()) {
                    case "home":
                        s.headline = obj.title;
                        s.home = obj;
                        break;
                    case "aktuelles":
                        s.news = obj;
                        s.news.type = "aktuelles";
                        break;
                    case "hotel":
                        s.hotel = obj;
                        break;
                    case "rooms":
                        s.rooms = obj;
                        s.rooms.preise.text += this.parseAllRoomPrices(s.rooms.preise, s.rooms.rooms);
                        s.roomPanels = [s.rooms.ausstattung,s.rooms.infos,s.rooms.hinweise];
                        break;
                    case "restaurant":
                        s.restaurant = obj;
                        break;
                    case "region":
                        s.region = obj;
                        break;
                    case "map":
                        s.anfahrt = obj;
                        break;
                    case "buchen":
                        s.buchen = obj;
                        break;
                    case "misc":
                        s.sonstiges = obj;
                        break;
                    default:
                        break;

                }
            }
            this.setState(s);
            this.configLoaded = true;
        }


    };

    parseRoomPrice (seasons, room) {
        /*var t = '<strong>Preise:</strong>';*/
        var t = '<strong>Unsere Preise für Sie in EUR pro Person und Tag inklusive 19% MwSt.:</strong>';
        t += '<table style="width:100%" class="PriceTable PriceTableRoom">';
        t += '<tr>';
        /*t += '<th class="colTitle"></th>';*/
        t += '<th class="colTitle">Saison 1</th>';
        t += '<th class="colTitle">Saison 2</th>';
        t += '<th class="colTitle">Saison 3</th>';
        /*t += '<th class="colTitle">Periode 6</th>';*/
        t += '</tr>';
        t += '<tr>';
        /*t += '<td class="roomName">' + room.headline + '</td>';*/
        t += '<td class="roomPrice">' + room.price_season_1 + '</td>';
        t += '<td class="roomPrice">' + room.price_season_2 + '</td>';
        t += '<td class="roomPrice">' + room.price_season_3 + '</td>';
        /*t += '<td class="roomPrice">' + room.price_season_4 + '</td>';*/
        t += '</tr>';
        t += '<tr>';
        /*t += '<td class="seasonDates"></td>';*/
        t += '<td class="seasonDates"><small>' + seasons.season_1 + '</small></td>';
        t += '<td class="seasonDates"><small>' + seasons.season_2 + '</small></td>';
        t += '<td class="seasonDates"><small>' + seasons.season_3 + '</small></td>';
        /*t += '<td class="seasonDates"><small>' + seasons.season_4 + '</small></td>';*/
        t += '</tr>';
        t += '</table>';

        return t;
    }

    parseAllRoomPrices (seasons, rooms) {
        var t = '<table style="width:100%" class="PriceTable PriceTableOverview">';
        t += '<tr>';
        t += '<th class="colTitle">Zimmer</th>';
        t += '<th class="colTitle centered">Saison 1</th>';
        t += '<th class="colTitle centered">Saison 2</th>';
        t += '<th class="colTitle centered">Saison 3</th>';
        /*t += '<th class="colTitle">Periode 6</th>';*/
        t += '</tr>';
        t += '<tr>';
        t += '<td></td>';
        t += '<td class="seasonDates"><small>' + seasons.season_1 + '</small></td>';
        t += '<td class="seasonDates"><small>' + seasons.season_2 + '</small></td>';
        t += '<td class="seasonDates"><small>' + seasons.season_3 + '</small></td>';
        /*t += '<td class="seasonDates"><small>' + seasons.season_4 + '</small></td>';*/
        t += '</tr>';
        for (var i = 0; i < rooms.length; i++) {
            var r = rooms[i];
            if (r.price_season_1 !== "" || r.price_season_2 !== "" || r.price_season_3 !== "") {
            r.text += this.parseRoomPrice (seasons, r);
                t += '<tr>';
                t += '<td class="roomName">' + r.headline + '</td>';
                t += '<td class="roomPrice">' + r.price_season_1 + '</td>';
                t += '<td class="roomPrice">' + r.price_season_2 + '</td>';
                t += '<td class="roomPrice">' + r.price_season_3 + '</td>';
                /*t += '<td class="roomPrice">' + r.price_season_4 + '</td>';*/
                t += '</tr>';
            }
        }
        t += '</table>';

        return t;

    }

    componentWillUnmount() {
        this.Events.scrollEvent.remove('begin');
        this.Events.scrollEvent.remove('end');
    }

    componentWillReceiveProps (nextProps) {

        let site,
            el,
            scrollTop,
            offset,
            subsite,
            overlayIds,
            isOverlay;

        site = nextProps.params.site;
        subsite = nextProps.params.idx;
        overlayIds = ['aktuelles','zimmer','sonstiges'];
        isOverlay = false;
        scrollTop = 0;
        offset = 0;

        //console.log("App - site: " + site);
        //console.log("App - subsite: " + subsite);

        if (site === undefined) {
            this.closeOverlay();
            this.closeBookingOverlay();
            return;
        }

        for (var k = 0; k < overlayIds.length; k++) {
            if (overlayIds[k] === site) {
                isOverlay = true;
                break;
            }
        }

        //console.log("App - isOverlay: " + isOverlay);

        if (isOverlay) {
            var subIdx = -1;
            if (subsite !== undefined) {
                if (!isNaN(Number(subsite))) {
                    subIdx = Number(subsite);
                }
            }

            this.closeBookingOverlay();

            if (subIdx >= 0) {
                this.changePageHandler(subIdx,"page", site);
                return;
            }
        }

        switch (site) {
            case "buchen":
                this.onBookingClick();
                return;
            case "sonstiges":
                this.changePageHandler(0,subsite,"footer");
                return;
            default:

                break;

        }

        var overlay = this.state.overlay;
        if (overlay.isVisible) {
            this.closeOverlay();
        }

        var bOverlay = this.state.bookingOverlay;
        if (bOverlay.isVisible) {
            this.closeBookingOverlay();
        }

        if (el === undefined) el = this.refs[site];

        if (el !== undefined) {
            scrollTop = el.offsetTop - offset;
        }

        ////console.log(("App - scrollTop: " + scrollTop);

        if (!isNaN(scrollTop)) {
            this.scroll.scrollTo(scrollTop, {
                duration: 500,
                delay: 0,
                smooth: true,
            });
        }

    }

    scrollToSite (site) {
        var scrollTop = this.refs[site].offsetTop;
        if (!isNaN(scrollTop)) {
            this.scroll.scrollTo(scrollTop, {
                duration: 200,
                delay: 0,
                smooth: true,
            });
        }
    }

    changePageHandler = (idx, type, page) => {
        //console.log(("changePageHandler App " + idx + " type: " + type + " page: " + page);

        var overlay = this.state.overlay;
        overlay.isVisible = true;
        overlay.rooms = undefined;
        overlay.articles = undefined;
        overlay.panels = undefined;


        if (page === "zimmer") {
            overlay.title = this.state.rooms.headline;
            overlay.type = "zimmer";
            overlay.rooms = this.state.rooms.rooms;
            overlay.idx = idx;
            overlay.articles = [this.state.rooms.preise];
            overlay.panels = this.state.roomPanels;
            overlay.image = this.state.rooms.images[0];
        } else {

            overlay.title = this.state.sonstiges.headline;

            overlay.idx = idx;

            overlay.type = page;

            if (page === "news" || page === "aktuelles") {
                overlay.title = this.state.news.headline;
                overlay.articles = this.state.news.articles;
                overlay.idx = idx;
                overlay.type = "aktuelles";
                overlay.image = this.state.news.images[0];
            } else {
                overlay.image = this.state.sonstiges.images[0];

                for (var i = 0; i < this.state.sonstiges.pages.length; i++) {
                    var p = this.state.sonstiges.pages[i];
                    if (p.title.toLowerCase() === type.toLowerCase()) {
                        p.type = type;
                        overlay.idx = i;
                        break;
                    }
                }

                overlay.title = this.state.sonstiges.title;
                overlay.articles = this.state.sonstiges.pages;
                overlay.type = "sonstiges";
            }


        }

        this.setState({overlay: overlay});

    }

    closeOverlay = () => {
        //console.log(("closeOverlay");
        var overlay = this.state.overlay;
        overlay.isVisible = false;

        this.setState({overlay: overlay});
    }

    closeBookingOverlay = () => {
        var bookingOverlay = this.state.bookingOverlay;
        bookingOverlay.isVisible = false;

        this.setState({bookingOverlay: bookingOverlay});
    }

    onButtonClick = (type, id) =>  {
        //console.log(("App - onButtonClick: type " + type + " id: " + id);
        if (type === "button") {
            this.changePageHandler(0,id,type)
        }
    }


    onSectionAccordionExpanded = (mode, expanded) =>  {
        //console.log((" - onSectionAccordionExpanded: " + mode + " / " + expanded);

    }
    onBookingClick = () =>  {
        //console.log(("onBookingClick");
        // this.closeOverlay();
        this.openDir21Modul()

        /*
        var overlay = this.state.buchen;
        overlay.isVisible = true;
        overlay.image = this.state.buchen.images[0];

        this.setState({bookingOverlay: overlay});
        */
    }

    openDir21Modul () {
        if (!window.d21_api) {
            setTimeout(() => this.openDir21Modul(), 500)
        } else {
            window.d21_api.ibe.open({'culture':'de-DE'})
        }
    }

  render() {

    let appClass = "";
    if (this.state.overlay.isVisible) {
        // NO SCROLL
        appClass = "App noscroll";
    } else {
        appClass = "App";
    }

    ////console.log(("App - appClass: " + appClass);

    return (
    <BodyScroll isScrollable={!this.state.overlay.isVisible && !this.state.bookingOverlay.isVisible}>

      <div className={appClass} ref="top">

          <div id="willkommen" className="element" ref="willkommen">
            <Home value={this.state.home} onChange={this.changePageHandler}/>
          </div>

          <div id="hotel" className="hotel" ref="hotel">
              <Section value={this.state.hotel} onExpand={() => this.scrollToSite('hotel')}/>
          </div>

          <div id="zimmer" className="element"  ref="zimmer">
              <Zimmer
                  title={this.state.rooms.headline}
                  rooms={this.state.rooms.rooms}
                  images={this.state.rooms.images}
                  onChange={this.changePageHandler}
                  onBookingClick={this.onBookingClick}
              />
          </div>

          <div id="restaurant" ref="restaurant">
              <Section value={this.state.restaurant} onExpand={() => this.scrollToSite('restaurant')}/>
          </div>

          <div id="region" className="element" ref="region">
              <Section value={this.state.region}
                       onExpand={() => {
                           this.setState({showWeatherWidget: false});
                           this.scrollToSite('region');
                       }}
                       onCollapse={() => this.setState({showWeatherWidget: true})}/>
              <div className="hidden-lg hidden-md">
                  <WeatherWidget isVisible={this.state.showWeatherWidget} ref={(d) => { this.weatherWidget = d; }} visible={true}></WeatherWidget>
              </div>
              <div className="hidden-xs hidden-sm">
                 <WeatherWidget isVisible={true}></WeatherWidget>
              </div>

          </div>

          <div id="anfahrt" className="element" ref="anfahrt">
              <Section value={this.state.anfahrt} onExpand={() => this.scrollToSite('anfahrt')}/>
          </div>

         <Footer onChange={this.changePageHandler} />

        <Header onButtonClick={this.onButtonClick} onBookingClick={this.onBookingClick}/>

        <Overlay value={this.state.overlay} onClose={this.closeOverlay} onBookingClick={this.onBookingClick}/>

        {/*<BookingOverlay value={this.state.bookingOverlay} onClose={this.closeBookingOverlay}></BookingOverlay>*/}
      </div>

    </BodyScroll>

    );
  }
}

export default App;




// WEBPACK FOOTER //
// ./src/App.js